/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 1/8/2023
 */

export const StatusEnum = Object.freeze({
	ACTIVE: "ACTIVE",
	DISABLED: "DISABLED",
	PENDING: "PENDING",
	ARCHIVED: "ARCHIVED",
	COMPLETED: "COMPLETED",
	ACCEPTED: "ACCEPTED",
	PENDING_PAYMENT: 'PENDING_PAYMENT',
	CONFIRMED: 'CONFIRMED',
	CANCELLED: 'CANCELLED'

})
